import { useMemo } from 'react'
import { useClockSelector } from './useClockSelector'

const toMinute = (now: Date) => Math.floor(now.getTime() / 60_000)

/**
 * The (overridable) current time, truncated to the minute and stable between
 * minutes — safe as a memo dependency where `getNow()`, a fresh `Date` per
 * call, recomputed the memo on every render.
 */
export function useMinuteNow(): Date {
  const minute = useClockSelector(toMinute)
  return useMemo(() => new Date(minute * 60_000), [minute])
}
